// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"610d2cfe","799":"27f9cb08"}[chunkId] + ".chunk.js";
};